const modifySubmissionAuthorOrder = function (
  { commit },
  { id, field, value }
) {
  commit("UPDATE_SUBMISSION_AUTHOR_ORDER", { id, field, value });
};

export default modifySubmissionAuthorOrder;
